import React from "react";
import { Box, Checkbox as ChakraCheckbox, cssVar, Text, } from "@chakra-ui/react";
import Balancer from "@hightouchio/react-wrap-balancer";
export function Checkbox({ isChecked, isDisabled = false, isIndeterminate = false, label, badge, description, onChange, ...props }) {
    return (React.createElement(Box, { ...props },
        React.createElement(Box, { display: "flex", alignItems: "center", gap: 2 },
            React.createElement(ChakraCheckbox, { isChecked: isChecked, isDisabled: isDisabled, isIndeterminate: isIndeterminate, onChange: onChange }, label),
            label && badge),
        description && (React.createElement(Text, { mt: 1, pl: 6, color: "text.secondary", sx: {
                [cssVar("hightouch-text-color").variable]: "text.secondary",
            } },
            React.createElement(Balancer, { ratio: 0.65 }, description)))));
}
